import React from 'react';
import './styles.scss';
import { FormControl, FormHelperText, FormLabel, TextField, InputAdornment } from "@mui/material";

export const inputStyle = {
    background: "#FDF6FA",
    borderRadius: '10px',
    transition: 'all 0.2s ease',
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: '#F0D6E4',
        transition: 'border-color 0.2s ease',
    },
    "&:hover": {
        background: '#FBEEF5',
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: '#E0A7C5',
    },
    "&.Mui-focused": {
        background: '#FFFFFF',
        boxShadow: '0 0 0 4px rgba(168, 33, 117, 0.10)',
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: '#A82175',
        borderWidth: '2px',
    },
    ".MuiInputBase-input": {
        height: "11px",
        minHeight: 'unset',
        minWidth: "34px !important",
        color: '#1A1A1A',
        fontSize: '14px',
        "&::placeholder": {
            color: '#B58FA4',
            opacity: 1,
        },
    },
    ".MuiInputAdornment-root": {
        color: '#A82175',
    },
};

export const customerInputStyle = {
    background: "#FAEFF5",
    borderRadius: '10px',
    transition: 'all 0.2s ease',
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: '#F0CDDB',
        transition: 'border-color 0.2s ease',
    },
    "&:hover": {
        background: '#FBE6EE',
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: '#E4A8BF',
    },
    "&.Mui-focused": {
        background: '#FFFFFF',
        boxShadow: '0 0 0 4px rgba(167, 44, 104, 0.12)',
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: '#A72C68',
        borderWidth: '2px',
    },
    ".MuiInputBase-input": {
        height: "11px",
        minHeight: 'unset',
        minWidth: "34px !important",
        color: '#1a1a2e',
        fontSize: '14px',
        fontFamily: 'helvetica-lt-std-roman',
        "&::placeholder": {
            color: '#9CA3AF',
            opacity: 1,
        },
    },
    ".MuiInputAdornment-root": {
        color: '#A72C68',
    },
};

export const labelStyle = {
    fontSize: "13px",
    color: '#1A1A1A !important',
    letterSpacing: '0.01em',
    textTransform: 'capitalize',
    fontWeight: 600,
    marginBottom: '6px',
    '&.Mui-focused': {
        color: '#1A1A1A !important',
    },
};

export const customerLabelStyle = {
    fontSize: "13px",
    color: '#4B5563 !important',
    letterSpacing: '0.01em',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontFamily: 'helvetica-lt-std-bold',
    marginBottom: '8px',
    '&.Mui-focused': {
        color: '#A72C68 !important',
    },
};

const FormInput = ({ name, label, isAuto, mb, disabled, placeholder, values, errors, touched, handleChange, multiline, rows, icon, customer }) => {
    const activeInputStyle = customer ? customerInputStyle : inputStyle;
    const activeLabelStyle = customer ? customerLabelStyle : labelStyle;
    return (
        <FormControl fullWidth sx={{ mb: mb || "16px" }}>
            <FormLabel sx={activeLabelStyle}>{label}</FormLabel>
            <TextField
                fullWidth
                disabled={!!disabled}
                name={name}
                sx={activeInputStyle}
                inputProps={{
                    autoComplete: isAuto ? 'on' : 'new-password',
                    form: {
                        autoComplete: isAuto ? 'on' : 'off',
                    },
                }}
                multiline={!!multiline}
                minRows={rows}
                maxRows={rows}
                placeholder={placeholder}
                value={values[name]}
                onChange={handleChange}
                error={touched[name] && Boolean(errors[name])}
                InputProps={{
                    startAdornment: icon ? (
                        <InputAdornment position="start" sx={{ width: '40px', color: customer ? '#C0357A' : '#94A3B8' }}>
                            <span style={{ width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                                {icon}
                            </span>
                        </InputAdornment>
                    ) : null,
                }}
            />
            {errors[name] && touched[name] && (
                <FormHelperText sx={{ color: '#DC2626', width: 'max-content', mx: 0, fontSize: '12px', mt: '4px' }}>
                    {errors[name]}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default FormInput;
